import React, { useState } from 'react';

//*MUI
import { Box, Popover, Typography, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';

//*files
import cssClasses from './FloorComponents.module.css';
import LeadStatusChip from '../LeadStatusChip';
import Dot from '../../Components/Icons/Dot';
import SyncIcon from '@mui/icons-material/Sync';
import ConfirmationAlert from '../ConfirmationAlert';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { errorTost, successTost } from '../../Services/Toast';
import axios from 'axios';

function BlockDiv({
  style,
  time,
  Size,
  flatNo,
  Price,
  displayUnitType,
  clicked,
  CheckBox = false,
  changeUnit,
  isSelected,
  margin,
  paired = false,
  pairedInfo = '',
  Name,
  NameTitle,
  Sale,
  UnitOf,
  RefreshUnit = false,
  align = false,
  UnitInfo,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [SyncUnitOpen , setSyncUnitOpen] = useState(false);
  const [unitData , setUnitData] = useState([]);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }
  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  function SyncUnit(unitNo) {
    console.log("details" , unitNo.projectId)
    presentLoader()
    axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}units/updateFarvisionStatus`, { project: unitNo.projectId }).then((resp) => {
      console.log(resp)
      if (resp.data.success) {
        successTost(`Unit ${unitNo?.unitId?.unitNo} Synced Successfully`)
        dismissLoader()
        setSyncUnitOpen(false)
      } else {
        errorTost("Something went wrong ! Please try again later")
        dismissLoader()
        setSyncUnitOpen(false)
      }
    }).catch((err) => {
      errorTost("Something went wrong ! Please try again later")
      dismissLoader()
      setSyncUnitOpen(false)
    })
  }
  return (
    <>
      <Box
      className={cssClasses.flexRow}
      style={{ backgroundColor: style.backgroundColor,border:style.border }}
      onClick={clicked}
    >
      <Box>
        {CheckBox === true? 
          <label className={cssClasses.container}>
            <input
              className={cssClasses.checkbox}
              type='checkbox'
              name=''
              id=''
              onChange={(e) => {
                e.stopPropagation();
                console.log("checkBox got clicked")
                changeUnit();
              }}
              onClick={(e) => e.stopPropagation()}
              checked={isSelected}
            />
            <span
              onClick={(e) => e.stopPropagation()}
              className={cssClasses.checkmark}
            ></span>
          </label>
        : <Box height={'2rem'} width={'2rem'}></Box>}
      </Box>

          {/* middlediv */}
      <Box  paddingTop={align === true ? "0" :"2rem"}>
        <Box style={{ color: style.color }} className={cssClasses.DetailsTitle} p={1}>
          {time}
        </Box>

        {Size !== '' && (
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle}
          >
            {Size}
          </Box>
        )}

        {displayUnitType !== '' && (
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle2}
          >
            ({displayUnitType})
          </Box>
        )}

        <Box style={{ color: style.color }} className={cssClasses.DetailsTitle}>
          {flatNo}
        </Box>

        <Box
          style={{ color: style.color }}
          className={cssClasses.DetailsTitle2}
        >
          {UnitOf}
        </Box>

        {Price && (
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle2}
          >
            ₹ {numberWithCommas(Price)}
          </Box>
        )}

        <Tooltip title={<h1>{NameTitle}</h1>}>
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle1}
          >
            {Name}
          </Box>
        </Tooltip>

        {paired && (
          <Box style={{ color: style.color }} className={cssClasses.paired}>
            <Box className={cssClasses.DetailsTitle} mr={0.2}>
              Paired
            </Box>
            <Box mt={0.2}>
              <InfoOutlinedIcon
                onClick={handleClick}
                style={{ width: "2rem", height: "2rem", color: "#344054" }}
              ></InfoOutlinedIcon>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
              >
                <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>
                  {pairedInfo}
                </Typography>
              </Popover>
            </Box>
          </Box>
        )}
        {Sale && (
          <Box display={"flex"} justifyContent={"center"}>
            <LeadStatusChip
              style={{
                color: "#B42318",
                backgroundColor: "#FEE4E2",
              }}
              label={"Not for Sale"}
              icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
            />
          </Box>
        )}

      </Box>

          {/* rightdiv */}
      <Box>
        {RefreshUnit === true? 
           <div
           style={{ color: style.color }}
           className={cssClasses.Box}
         >
          <div className={cssClasses.IconBox} 
          onClick={(e) => {e.stopPropagation();
            console.log("refresh button got clicked!!!!")
            console.log("Unit-Info" , UnitInfo)
            setSyncUnitOpen(true)
            setUnitData(UnitInfo)
          }}
          >
          <SyncIcon   style={{height:"2.5rem" , width:"2.5rem"}}/>
          </div>
          
         </div>
         : <Box height={'2rem'} width={'2rem'}></Box>}
          
      </Box>
     
    </Box>

    {SyncUnitOpen && (
         <ConfirmationAlert
         open={SyncUnitOpen}
         close={() => setSyncUnitOpen(false)}
         buttonTitle={'No'}
         title={'Warning'}
         subTitle={`Are you sure you want to Refresh the Unit of ${flatNo} ?`}
         returnRespButton={'Yes'}
         confirm={(e) => {
           console.log("value" , e)
           console.log("user-value" , unitData)
           if(e === 'confirmed') {
              SyncUnit(unitData)
           } else if(e === 'rejected') {
             setSyncUnitOpen(false)
           }
         }}
       />
      )
      }
    </>
    // <Box
    //   className={cssClasses.flexCol}
    //   style={{ backgroundColor: style.backgroundColor }}
    //   onClick={clicked}
    // >
    //   <Box padding={"0.3rem 1rem 0 0"} display={"flex"} flexDirection={"row"}>
    //     {CheckBox === true && (
    //       <label className={cssClasses.container}>
    //         <input
    //           className={cssClasses.checkbox}
    //           type="checkbox"
    //           name=""
    //           id=""
    //           onChange={(e) => {
    //             e.stopPropagation();
    //             changeUnit();
    //           }}
    //           onClick={(e) => e.stopPropagation()}
    //           checked={isSelected}
    //         />
    //         <span
    //           onClick={(e) => e.stopPropagation()}
    //           className={cssClasses.checkmark}
    //         ></span>
    //       </label>
    //     )}
    //     {/* <Box style={{ color: style.color }} className={cssClasses.DetailsTitle}>
    //         {time}
    //       </Box> */}
    //   </Box>

    //   {/* <Box mt={margin}> */}
    //   <Box className={cssClasses.unitBlock}>
    //     <Box display={"flex"} flexDirection={"row"}>
    //       {/* // ! vedashree changes */}

    //       <Box
    //         style={{ color: style.color }}
    //         className={cssClasses.DetailsTitle}
    //       >
    //         {time}
    //       </Box>

    //     </Box>
    //     {Size !== "" && (
    //       <Box
    //         style={{ color: style.color }}
    //         className={cssClasses.DetailsTitle}
    //       >
    //         {Size}
    //       </Box>
    //     )}
    //     {displayUnitType !== "" && (
    //       <Box
    //         style={{ color: style.color }}
    //         className={cssClasses.DetailsTitle2}
    //       >
    //         ({displayUnitType})
    //       </Box>
    //     )}
    //     <Box style={{ color: style.color }} className={cssClasses.DetailsTitle}>
    //       {flatNo}
    //     </Box>

    //     <Box style={{ color: style.color }} className={cssClasses.DetailsTitle2}>
    //       {UnitOf}
    //     </Box>
    //     {Price && (
    //       <Box
    //         style={{ color: style.color }}
    //         className={cssClasses.DetailsTitle}
    //       >
    //         ₹ {numberWithCommas(Price)}
    //       </Box>
    //     )}
    //     <Tooltip title={<h1>{NameTitle}</h1>}>
    //       <Box
    //         style={{ color: style.color }}
    //         className={cssClasses.DetailsTitle1}
    //       >
    //         {Name}
    //       </Box>
    //     </Tooltip>

    //     {/* </Box> */}
    //     {paired && (
    //       <Box style={{ color: style.color }} className={cssClasses.paired}>
    //         <Box className={cssClasses.DetailsTitle} mr={0.2}>
    //           Paired
    //         </Box>
    //         <Box mt={0.2}>
    //           <InfoOutlinedIcon
    //             onClick={handleClick}
    //             style={{ width: "2rem", height: "2rem", color: "#344054" }}
    //           ></InfoOutlinedIcon>
    //           <Popover
    //             id={id}
    //             open={open}
    //             anchorEl={anchorEl}
    //             onClose={handleClose}
    //             anchorOrigin={{
    //               vertical: "bottom",
    //               horizontal: "right",
    //             }}
    //           >
    //             <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>
    //               {pairedInfo}
    //             </Typography>
    //           </Popover>
    //         </Box>
    //       </Box>
    //     )}
    //     {Sale && (
    //       <Box display={"flex"} justifyContent={"center"}>
    //         <LeadStatusChip
    //           style={{
    //             color: "#B42318",
    //             backgroundColor: "#FEE4E2",
    //           }}
    //           label={"Not for Sale"}
    //           icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
    //         />
    //       </Box>
    //     )}
    //   </Box>

    //   <Box className={cssClasses.container} ml={'auto'}>
    //        <Box
    //        style={{ color: "#000000" }}
    //        className={cssClasses.checkbox}

    //      >
    //       <SyncIcon style={{height:"2rem" , width:"2rem"}}/>
    //      </Box>
    //      </Box>
    // </Box>
  
  );
}

function AllotmentDiv({ style, content, Quantity }) {
  return (
    <Box
      style={{ backgroundColor: style.backgroundColor }}
      className={cssClasses.AllotmentTitle}
    >
      {content} : {Quantity}
    </Box>
  );
}

function PairedUnitBlock({
  style,
  time,
  Wing,
  Type,
  Price,
  Unit1,
  Unit2,
  clicked,
  changeWingStatus,
  isSelected,
  CheckBox = true,
}) {
  return (
    <Box
      style={{ backgroundColor: style.backgroundColor }}
      className={cssClasses.wrapperBlock}
    >
      <Box className={cssClasses.containerBlock} onClick={clicked}>
        <Box>
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle}
          >
            {Wing}
          </Box>
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle}
          >
            {Type}
          </Box>
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle}
          >
            {Unit1}
          </Box>
        </Box>
        <Box style={{ color: style.color }} className={cssClasses.DetailsTitle}>
          {' '}
          {Price}
        </Box>
        <Box>
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle}
          >
            {Wing}
          </Box>
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle}
          >
            {Type}
          </Box>
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle}
          >
            {Unit2}
          </Box>
        </Box>
      </Box>
      {CheckBox === true && (
        <Box className={cssClasses.wrapperCheckBox} mt={1}>
          <label className={cssClasses.container}>
            <input
              className={cssClasses.checkbox}
              type='checkbox'
              name=''
              id=''
              onChange={changeWingStatus}
              checked={isSelected}
            />
            <span className={cssClasses.checkmark}></span>
          </label>
        </Box>
      )}
    </Box>
  );
}

// ?? Just to show Floor Number and checkbox
function FloorBlock({
  style,
  floorNo,
  isSelected,
  CheckBox = false,
  handleChange,
  planName,
}) {
  return (
    <Box
      style={{
        backgroundColor: style.backgroundColor ?? '#F2F4F7',
        width: '23%',
      }}
      className={cssClasses.wrapperBlock2}
    >
      <Box
        className={cssClasses.containerBlock}
        style={{
          flexDirection: 'column',
          margin: '1rem',
          width: 'calc(100% - 2rem)',
        }}
      >
        {floorNo}
        {planName !== null && (
          <div
            style={{
              textOverflow: 'ellipsis',
              width: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
            title={planName}
          >
            {planName}
          </div>
        )}
      </Box>
      {CheckBox === true && (
        <Box class={cssClasses.wrapperCheckBox2}>
          <label class={cssClasses.container}>
            <input
              class={cssClasses.checkbox}
              type='checkbox'
              name=''
              id=''
              onChange={handleChange}
              checked={isSelected}
            />
            <span class={cssClasses.checkmark}></span>
          </label>
        </Box>
      )}
    </Box>
  );
}
export { BlockDiv, AllotmentDiv, PairedUnitBlock, FloorBlock };
